export const CHECKOUT_URL = 'https://caligrafia-21-dias.impultienda.ar/checkout'

export const META_PIXEL_ID = '1030901213184541'

export const SUPPORT_EMAIL = 'soporte@ganaconconocimiento.com'

export const PRECIO_VENTA = '$19.990'
export const PRECIO_TACHADO = '$49.990'
export const VALOR_TOTAL = '$115.930'
export const VALOR_BONOS = '$65.940'
export const AHORRO = '83%'

export const IMG_PACK_PRINCIPAL =
  'https://lh3.googleusercontent.com/d/18sbyMg_a2YbLDgrzRcYKfAbY09xpqJCV'

export const IMG_BONOS = [
  'https://lh3.googleusercontent.com/d/1Fd-ZKppNLJnS5jqmzSus1TgT0yY1G7YK',
  'https://lh3.googleusercontent.com/d/1yJHxcRTSZMsgOVK0uhMFhOH9lSsmnSG1',
  'https://lh3.googleusercontent.com/d/1zVsufTNGBu7WGPagCugS3B85PDP6bWFZ',
  'https://lh3.googleusercontent.com/d/1tYiqxcCc92J6fhS70gndWN7mCmquEjq3',
  'https://lh3.googleusercontent.com/d/15WdSLSDVaGAZe1rfBKoNecUgOZusTpW7',
  'https://lh3.googleusercontent.com/d/1Vnyof3JnJYx-8qTgkJk3RqeG1RnrwXqF',
]

export const IMG_INTERIOR = [
  {
    src: 'https://lh3.googleusercontent.com/d/1lfG6Dqs_iTQuKc_nBdvb5lm9yO9KYG5Q',
    caption: 'Ficha de ejercicio: una letra por vez, con renglones guía.',
  },
  {
    src: 'https://lh3.googleusercontent.com/d/12UjY1_3FuixpF94UBdeEiT0MTslG2eAf',
    caption: 'El calendario de los 21 días, día por día.',
  },
  {
    src: 'https://lh3.googleusercontent.com/d/1kyF-coQwuuI-xAScJnAdJlEsC8AKXjhg',
    caption: 'Ficha de ejercicio: palabras y frases enlazadas.',
  },
  {
    src: 'https://lh3.googleusercontent.com/d/1Eq2zb4KmQhMXDRsRqyRl3Bs8upF9MadM',
    caption: 'Tabla de qué corregir y qué dejar pasar.',
  },
]
